export default {
  "languageDisplayName": "Español",
  "greeting": "saludo",
  "Hello": "Hola",
  "Profile": "Perfil",
  "Interests": "Intereses",
  "Recurring Payments": "Pagos recurrentes",
  "Payment Methods": "Método de pago",
  "Transactions": "Transacciones",
  "Passport": "Passporte",
  "Wallet": "Billetera",
  "Subscriptions": "Suscripciones",
  "Projects": "Proyectos",
  "Campaigns": "Campañas",
  "Volunteer": "Voluntario",
  "Events": "Eventos",
  "Settings": "Ajustes",
  "My": "Mi",
  "Groups": "Grupos",
  "Awards": "Premios",
  "Change": "Cambio",
  "Image": "Imagen",
  "You have no": "Tu no tienes",
  "Now": "Ahora",
  "Booths": "Cabinas",
  "You don't have any listed": "Tu no tienes a nadie en la lista",
  "Add": "Añadir",
  "You Might Like:": "Te podría gustar ",
  "Start Date": "Fecha de inicio",
  "End Date": "Fecha de finalización",
  "Filter": "Filtro",
  "Download": "Descarga",
  "Saved Cards": "Cartas guardadas",
  "Saved Debits": "Débitos guardados",
  "Recommended": "Recomendado",
  "Subscribe": "Suscribir",
  "Unsubscribe": "Cancelar suscripción",
  "Click to": "Haga click para",
  "Update": "Actualizar",
  "Register": "Registrar",
  "Unregister": "Cancelar el registro",
  "Add More Interests": "Agregar más intereses",
  "Add More Skills": "Agregar más habilidades",
  "Search": "Buscar",
  "Close": "Cerrar",
  "Credit Card": "Tarjeta de Crédito",
  "card": "Tarjeta",
  "Debit": "Débito",
  "Cancel": "Cancelar",
  "Account Name": "Nombre de la cuenta",
  "Institution Name": "Nombre de institución",
  "BSB Number": "Número BSB",
  "Account Number": "Número de cuenta",
  "Cardholder Name": "Nombre del titular de la tarjeta",
  "Card Number": "Número de tarjeta",
  "Expiration Date": "Fecha de vencimiento",
  "Cannot Be Empty": "No puede estar vacío",
  "Not Valid": "No es válido",
  "Save": "Guardar",
  "Cannot Be Empty or Contain Numbers": "No puede estar vacío o contener números",
  "Login": "Ingresar",
  "Awaiting Login": "Esperando ingreso",
  "Awaiting Registration": "En espera de registro",
  "Please": "Por favor",
  "Logout": "Cerrar Sesión",
  "Offline": "Desconectado",
  "No Popups": "Sin ventanas emergentes/ Sin Pop Ups",
  "We have noticed you have blocked popups, please make sure you have them enabled for this site.": "Nos hemos dado cuenta que has bloqueado los pop ups, por favor asegúrese que las tiene deshabilitadas para este sitio",
  "Voting": "Votando",
  "Site Settings": "Ajuste del sitio",
  "My Settings": "Mis ajustes",
  "Security Settings": "Ajustes de seguridad",
  "2-Factor Authentication": "Autenticación de 2 factores",
  "Language": "Lenguaje",
  "Name": "Nombre",
  "Addresses": "Direcciones",
  "Work": "Trabajo",
  "Home": "Casa/ Inicio/ Hogar",
  "Other": "Otro",
  "Phone Numbers": "Numeros de telefono",
  "Email Addresses": "Direcciones de correo",
  "First Name": "Primer nombre",
  "Last Name": "Apellido",
  "Address Type": "Tipo de dirección",
  "Street Address 1": "Dirección de calle 1",
  "Street Address 2": "Dirección de calle 2",
  "City": "Ciudad",
  "State": "Estado",
  "Postcode": "Código Postal",
  "Country": "País",
  "Phone Number Type": "Tipo de número de teléfono",
  "Email Type": "Tipo de correo electrónico",
  "Custom Type": "Tipo de personalización",
  "Number": "Número",
  "Email": "Email / Correo electrónico",
  "Emails": "Correos electrónicos",
  "Phone": "Teléfono",
  "Phones": "Telefonos",
  "Address": "Dirección",
  "Add Address": "Añadir Dirección",
  "Add Phone": "Añadir Teléfono",
  "Add Email": "Agregar Correo Electrónico",
  "Accommodation": "alojamiento",
  "Mobile": "Móvil / Teléfono celular",
  "View": "Ver / Vista",
  "No Groups": "No tienes grupos",
  "Recommended Groups": "Grupos recomendados",
  "Roles": "Roles",
  "Admin": "Administración",
  "Photos": "Fotos",
  "Join": "Unirse",
  "Leave": "Salir",
  "Joined": "Unido",
  "Member": "Miembro",
  "Members": "Miembros",
  "Are you sure?": "Estás seguro?",
  "Yes": "Si",
  "No": "No",
  "Fitness": "Fitness / Aptitud/ estado físico ",
  "Help": "Ayuda",
  "Gallery": "Galeria",
  "Support": "Apoyo",
  "Unsupport": "Retirar apoyo",
  "Skills": "Habilidades",
  "Communities": "Comunidades",
  "Click here to enter": "Haga click aca para entrar",
  "Rooms": "Habitaciones",
  "Boards": "Tableros",
  "Cloud": "Nube/ Cloud*",
  "Future": "Futuro",
  "Churches": "Iglesias",
  "Password": "Contraseña",
  "password": "contraseña",
  "New Password": "Nueva contraseña",
  "Old Password": "Vieja contraseña",
  "Confirm Password": "Confirmar contraseña",
  "Subscribers": "Seguidores",
  "Browse": "Vistazo",
  "Past Events": "Eventos Pasados",
  "Future Events": "Eventos Futuros",
  "Create": "Crear",
  "Edit": "Editar",
  "Issues": "Cuestiones",
  "Organizer": "Organizador",
  "Next": "Siguiente",
  "Back": "Espalda",
  "Confirm": "Confirmar",
  "Select Payment Method": "Seleccione El Método De Pago",
  "Please provide a payment method": "Por favor proporcione un método de pago",
  "Select A Support Level": "Seleccione Un Nivel De Soporte",
  "Your support will be sent from your selected payment method:": "Su soporte será enviado desde su método de pago seleccionado:",
  "My Gallery": "Mi Galería",
  "Local Artists": "Artistas Locales",
  "My Fitness": "Mi Estado Físico",
  "Next Due": "Lo Próximo Por Hacer",
  "Frequency": "Frecuencia",
  "Status": "Estado",
  "Link Your Fitbit": "Vincula Tu Fitbit",
  "Link Your Strava": "Vincula tu Strava",
  "Active": "Activo",
  "Cancelled": "Cancelado",
  "Tracker": "Rastreador",
  "Mobile Number": "Número de Teléfono Móvil",
  "Day": "Día",
  "Month": "Mes",
  "Year": "Año",
  "Date Of Birth": "Fecha De Nacimiento",
  "Sign Up": "Regístrate",
  "Check In": "Registrarse",
  "News": "Noticias",
  "Deregister": "Darse de baja",
  "What's On": "Que esta pasando",
  "On Now": "Pasando Ahora",
  "Coming Up": "Pasando Después",
  "There are currently no upcoming events": "Actualmente no hay eventos próximos",
  "Next Up": "Próximo",
  "Near Me": "Cerca de mí",
  "Goals": "Metas",
  "Connect": "Conectar",
  "Select An Option": "Elige Una Opcion",
  "Mentors": "Mentores",
  "Employment": "El Empleo",
  "Log In": "Iniciar Sesión",
  "Log Out": "Cerrar Sesión",
  "Please log in or sign up to continue.": "Por favor, ingresa o registrate para continuar.",
  "Add your group": "Agrega tu grupo",
  "Preferred": "Preferido",
  "Read More": "Sigue Leyendo",
  "Description": "Descripción",
  "Submit": "Enviar",
  "Subject": "Sujeta",
  "Message": "Mensaje",
  "Send Me A Copy": "Enviame Una Copia",
  "Contacts": "Contactos",
  "Followers": "Seguidoras",
  "Follow": "Seguir",
  "Following": "Siguiendo",
  "Contact Number": "Número De Contacto",
  "Any unsaved information may be lost": "Es posible que se pierda cualquier información no guardada",
  "Add Location": "Añadir lugar",
  "Edit Location": "Editar ubicación",
  "Last Logged In": "Último inicio de sesión",
  "Your Connections": "Tus conexiones",
  "There are no connections currently linked to your account": "Actualmente no hay conexiones vinculadas a su cuenta",
  "Connection Type": "Tipo de conección",
  "Remove Connection": "Quitar conexión",
  "Connect To: ": "Conectarse a: ",
  "Timezone": "Zona horaria",
  "forgotPassword": "No se mi contraseña",
  "createNewAccount": "Crear una nueva cuenta",
  "logInWith": "Iniciar sesión con",
  "orEnterYour": "o usa tu",
  "usernameOrEmail": "usuario o correo electrónico",
  "passwordRequired": "se requiere contraseña",
  "enterPasswordFor": "escriba la contraseña para",
  "authenticationFailed": "falló la autenticación",
  "signIn": "iniciar sesión",
  "iHaveAnAccount": "tengo una cuenta",
  "termsAndPrivacy": "érminos y privacidad",
  "securedBy": "asegurado por ",
  "Delete": "Borrar",
  "Please Wait": "Espere por favor",
  "loadingDiscussions": "¡Estamos cargando tus discusiones de chat!",
  "No Discussions": "¡Sin discusiones!",
  "joinDiscussion": "¡Únase a una discusión para que se muestre aquí!",
  "Discussion": "Discusión",
  "Log in with :": "Iniciar sesión con:",
  "Powered By:": "Desarrollado por:",
  "Please accept the latest": "Por favor, acepte el último ter",
  "Terms": "Términos",
  "Privacy Policy": "Política de Privacidad",
  "terms": "términos",
  "privacy policy": "política de privacidad",
  "willRecieveFollowingInfo": "recibirá la siguiente información:",
  "Email Address": "Dirección de correo electrónico",
  "and": "y",
  "We Use Cookies": "Nosotras usamos cookies",
  "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Las cookies nos ayudan a manejar muchos procesos que requiere nuestra plataforma, acepte o revise nuestra configuración disponible",
  "ACCEPT ALL": "ACEPTAR TODO",
  "REJECT ALL": "RECHAZAR TODO",
  "ACCEPT CURRENT SELECTION": "ACEPTAR SELECCIONES ACTUALES",
  "SETTINGS": "AJUSTES",
  "Manage cookie preferences": "Administrar preferencias de cookies",
  "Close modal": "Cerrar modal",
  "Strictly Necessary cookies": "Cookies estrictamente necesarias",
  "These cookies are essential for the proper functioning of the website and cannot be disabled.": "Estas cookies son esenciales para el correcto funcionamiento del sitio web y no se pueden deshabilitar.",
  "Performance and Analytics": "Rendimiento y análisis",
  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.": "Estas cookies recopilan información sobre cómo utiliza nuestro sitio web. Todos los datos son anónimos y no se pueden usar para identificarlo.",
  "ACCEPT REQUIRED": "ACEPTAR REQUERIDO",
  "Terms and Privacy Policy Links": "Términos y enlaces de política de privacidad",
  "Services": "Servicios",
  "Profile Pages": "Páginas de perfil",
  "Success": "Éxito",
  "Your disconnection request has successfully been processed": "Su solicitud de desconexión ha sido procesada con éxito",
  "Disconnecting will cause a new authorization prompt on next login to any related services": "La desconexión generará una nueva solicitud de autorización en el próximo inicio de sesión en cualquier servicio relacionado",
  "Legal": "Legal",
  "Available Services": "Servicios disponibles",
  "Link": "Enlace",
  "Disconnect": "Desconectar",
  "Agreed": "Acordado"
};